import { useProductReportControllerGetProductPriceHistory } from "@/api/types/main";
import { GetProductPriceHistoryResponseDTO } from "@/api/types/main/schemas";
import { LoadingSpinner } from "@/components/custom-ui/loading.spinner";
import { useCommersCardColumns } from "@/hooks/useCommersCardColumns";
import { TableIds } from "@/store/tables";
import { TransformCardData } from "./commers.card.rating";
import { useParams } from "react-router-dom";
import UseGetFlatRowsTable from "@/hooks/useGetFlatRowsTable";
import { TanstackTable } from "@/components/custom-ui/tables/tanstack.table";
import {
  MemoizedTanstackTableHeader,
  TanstackTableHeader,
} from "@/components/custom-ui/tables/tanstack.table.header";
import {
  MemoizedTanstackTableBody,
  TanstackTableBody,
} from "@/components/custom-ui/tables/tanstack.table.body";
import { DndSortableHeadersContext } from "@/components/tables/dnd.sortable.headers.context";
import { useTableDataRangeStore } from "@/store/table.data.range";
import { format } from "date-fns";

const READABLE_PRICES_CARD_LABELS: Partial<
  Record<keyof GetProductPriceHistoryResponseDTO, string>
> = {
  oldPrice: "Старая цена",
  price: "Цена",
  priceWithCard: "Цена с картой",
  priceWithSpp: "Цена с СПП",
  sppPercent: "Процент СПП",
};

export const CommersCardPrices = () => {
  const dateRange = useTableDataRangeStore((store) => store.dateRange);
  const { id } = useParams<{ id: string }>();
  const productId = Number(id);

  const { data, isLoading, isError, error } = useProductReportControllerGetProductPriceHistory(
    productId,
    {
      periodEnd: format(dateRange.to, "yyyy-MM-dd"),
      periodStart: format(dateRange.from, "yyyy-MM-dd"),
    },
    {
      query: {
        queryKey: ["card", "price", dateRange.from, dateRange.to, productId],
        select: (data) => {
          return Object.keys(data).map(
            (field): TransformCardData => ({
              label:
                READABLE_PRICES_CARD_LABELS[field as keyof GetProductPriceHistoryResponseDTO] ||
                "Значение не добавлено",
              data: data[field as keyof GetProductPriceHistoryResponseDTO],
            })
          );
        },
      },
    }
  );
  const columns = useCommersCardColumns({ dateRange: dateRange });

  const { table, columnSizeVars, columnOrder } = UseGetFlatRowsTable({
    data: data || [],
    columns,
    tableId: TableIds.Commers_PriceCard,
  });

  if (isError) return <div>{error?.message}</div>;
  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="h-full flex flex-col">
      <TanstackTable style={{ width: table.getTotalSize(), ...columnSizeVars }} className="flex-1">
        {table.getState().columnSizingInfo.isResizingColumn ? (
          <>
            <MemoizedTanstackTableHeader table={table} columnOrder={columnOrder} sticky="true" />
            <MemoizedTanstackTableBody table={table} columnOrder={columnOrder} />
          </>
        ) : (
          <>
            <DndSortableHeadersContext table={table} tableId={TableIds.Commers_PriceCard}>
              <TanstackTableHeader table={table} columnOrder={columnOrder} sticky="true" />
              <TanstackTableBody table={table} columnOrder={columnOrder} />
            </DndSortableHeadersContext>
          </>
        )}
      </TanstackTable>
    </div>
  );
};
